import AssignmentGeneratorSelectionView from "@features/assignments/AssignmentGeneratorSelection/view";

const AssignmentGeneratorSelection = () => {
  return <AssignmentGeneratorSelectionView />;
};

export default AssignmentGeneratorSelection;
